import { render, staticRenderFns } from "./plusvip.vue?vue&type=template&id=f2ae7062&scoped=true"
import script from "./plusvip.vue?vue&type=script&lang=js"
export * from "./plusvip.vue?vue&type=script&lang=js"
import style0 from "./plusvip.vue?vue&type=style&index=0&id=f2ae7062&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2ae7062",
  null
  
)

export default component.exports